import NextLink from "next/link";
import type { MouseEventHandler } from "react";

import { TbWordmark } from "@/components/brand/tb-wordmark";
import {
  SITE_HEADER_LOGO_WIDTH_CLASS,
  SITE_HEADER_SURFACE_MOTION_CLASS,
} from "@/components/shared/site-header-frame";
import { cn } from "@/lib/utils";

type SiteHeaderLogoProps = {
  /** Home, or the top of the page when already there. */
  href: string;
  /**
   * Where the press leads, for whoever cannot see it. The wordmark itself never changes; only
   * a host's destination does (`logoDestination`) — and it is not always Meu Painel: the host of
   * a draft has no such tab, and their place is Minha Lista.
   */
  destination?: "home" | "panel" | "lista";
  /** Colour and its transition: the wordmark paints `currentColor`. */
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

/**
 * The brand's wordmark as the way home — the artwork, never lettering set in type, at one size:
 * every header of the product opens with this.
 */
const DESTINATION_LABEL = {
  home: "Tania Bulhões, ir para a página inicial",
  panel: "Tania Bulhões, ir para Meu Painel",
  lista: "Tania Bulhões, ir para Minha Lista",
} as const;

export function SiteHeaderLogo({ href, destination = "home", className, onClick }: SiteHeaderLogoProps) {
  return (
    <NextLink
      href={href}
      onClick={onClick}
      aria-label={DESTINATION_LABEL[destination]}
      className={cn(
        "flex flex-none items-center text-[var(--fg)] transition-colors hover:text-tb-green focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tb-green focus-visible:ring-offset-2",
        SITE_HEADER_SURFACE_MOTION_CLASS,
        className,
      )}
    >
      <TbWordmark className={SITE_HEADER_LOGO_WIDTH_CLASS} />
    </NextLink>
  );
}
